import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=3308d051&scoped=true&"
import script from "./Flags.vue?vue&type=script&lang=js&"
export * from "./Flags.vue?vue&type=script&lang=js&"
import style0 from "./Flags.vue?vue&type=style&index=0&id=3308d051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308d051",
  null
  
)

export default component.exports